import { Button, Text } from '@change/ds-core-ui';
import { LockIcon } from '@change/ds-icons';

import { getLocation } from '@change-corgi/core/window';
import { Translate } from '@change-corgi/core-react/i18n';

import { usePageAdminTools } from './hooks/usePageAdminTools';

export const PageAdminTools: React.FC = () => {
	const {
		data: { isStaff, movementId, movementSlug, owner },
		actions: { handleEditPetitionsClick, handleAddPetitionsClick },
	} = usePageAdminTools();
	const location = getLocation();

	if (!isStaff) {
		return null;
	}

	return (
		<section className="bg-fill-inverse-weak py-4">
			<div className="container">
				<Text as="p" variant="heading" size="small">
					<LockIcon /> <Translate value="corgi.movement.show.admin_toolbar.title" />
				</Text>
				<div className="flex flex-row gap-2 py-4">
					<Button
						as="a"
						variant="secondary"
						size="small"
						href={`/admin/m/${movementId}`}
						data-testid="edit"
						data-qa="edit"
						onClick={handleEditPetitionsClick}
					>
						<Translate value="corgi.movement.show.admin_toolbar.edit_button" />
					</Button>
					<Button
						as="a"
						variant="secondary"
						size="small"
						href={`/admin/movement_petitions/new?movement_id=${movementId}`}
						data-testid="add-petitions"
						data-qa="add-petitions"
						onClick={handleAddPetitionsClick}
					>
						<Translate value="corgi.movement.show.admin_toolbar.add_petitions_button" />
					</Button>
				</div>
				{movementSlug && (
					<Text as="p" variant="body" size="small">
						Canonical URL: {location.origin}/m/{movementSlug}
					</Text>
				)}
				<Text as="p" variant="body" size="small">
					Movement owner: {owner.displayName} (ID: {owner.id})
				</Text>
			</div>
		</section>
	);
};
